import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  "data-testid": "step-riskAssessment",
  class: "container"
}
const _hoisted_2 = { class: "container__standard-header" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "row custom-select-wrapper" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "row custom-select-wrapper" }
const _hoisted_8 = { class: "row custom-select-wrapper" }
const _hoisted_9 = { class: "row custom-select-wrapper mb-0" }
const _hoisted_10 = { class: "risk-assessment-description" }
const _hoisted_11 = { class: "row custom-select-wrapper mb-0" }
const _hoisted_12 = { class: "risk-assessment-description" }
const _hoisted_13 = { class: "row custom-select-wrapper mb-0" }
const _hoisted_14 = { class: "risk-assessment-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t(`${_ctx.TRANSLATION_KEY}.riskAssessmentHeader`)), 1),
    _createElementVNode("form", {
      onSubmit: _withModifiers(($event: any) => (null), ["prevent"])
    }, [
      _createElementVNode("div", {
        class: "risk-assessment-description fz-12",
        innerHTML: _ctx.t(`${_ctx.TRANSLATION_KEY}.questionnaireDescription`)
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Select, {
          name: "employmentStatus",
          "item-list": _ctx.employmentStatusOptions,
          label: _ctx.t(`${_ctx.TRANSLATION_KEY}.employmentStatus`),
          placeholder: _ctx.t(`${_ctx.TRANSLATION_KEY}.employmentStatus`),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData.employmentStatus = $event))
        }, null, 8, ["item-list", "label", "placeholder"])
      ]),
      (
                    _ctx.formData.employmentStatus === 'EMPLOYED' ||
                    _ctx.formData.employmentStatus === 'SELF_EMPLOYED' ||
                    _ctx.formData.employmentStatus === 'BUSINESS_OWNER' ||
                    _ctx.formData.employmentStatus === 'STUDENT_WITH_EMPLOYMENT'
                )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Select, {
                name: "natureOfBusiness",
                "item-list": _ctx.natureOfBusinessOptions,
                label: _ctx.t(`${_ctx.TRANSLATION_KEY}.natureOfBusiness`),
                placeholder: _ctx.t(`${_ctx.TRANSLATION_KEY}.natureOfBusiness`),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.natureOfBusiness = $event))
              }, null, 8, ["item-list", "label", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Select, {
                name: "position",
                "item-list": _ctx.roleOptions,
                label: _ctx.t(`${_ctx.TRANSLATION_KEY}.role`),
                placeholder: _ctx.t(`${_ctx.TRANSLATION_KEY}.role`),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.position = $event))
              }, null, 8, ["item-list", "label", "placeholder"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Select, {
          name: "sourceOfFunds",
          "item-list": _ctx.sourceOfFundsOptions,
          label: _ctx.t(`${_ctx.TRANSLATION_KEY}.sourceOfFunds`),
          placeholder: _ctx.t(`${_ctx.TRANSLATION_KEY}.sourceOfFunds`),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.sourceOfFunds = $event))
        }, null, 8, ["item-list", "label", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t(`${_ctx.TRANSLATION_KEY}.sourceOfFundsDisclaimer`)), 1),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Select, {
          name: "income",
          "item-list": _ctx.incomeOptions,
          label: _ctx.t(`${_ctx.TRANSLATION_KEY}.income`),
          placeholder: _ctx.t(`${_ctx.TRANSLATION_KEY}.income`),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.income = $event))
        }, null, 8, ["item-list", "label", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t(`${_ctx.TRANSLATION_KEY}.incomeDisclaimer`)), 1),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_Select, {
          name: "savings",
          "item-list": _ctx.savingsOptions,
          label: _ctx.t(`${_ctx.TRANSLATION_KEY}.savings`),
          placeholder: _ctx.t(`${_ctx.TRANSLATION_KEY}.savings`),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.savings = $event))
        }, null, 8, ["item-list", "label", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t(`${_ctx.TRANSLATION_KEY}.savingsDisclaimer`)), 1),
      _createVNode(_component_SubmitButton, {
        action: _ctx.Action.RISK_ASSESSMENT,
        "button-value": _ctx.t(`${_ctx.TRANSLATION_KEY}.next`),
        data: _ctx.formData,
        "data-testid": "btn-riskAssessment-nextStep",
        class: "button button--submit",
        disabled: !_ctx.formIsValid,
        onClick: _ctx.handleNextStep
      }, null, 8, ["action", "button-value", "data", "disabled", "onClick"])
    ], 40, _hoisted_3)
  ]))
}